import { url } from "../../Components/url";
import { fetchWithAuth } from "../../Components/FetchWithAuth";

const BASE = `${url.replace(/\/+$/, "")}/api/marketing-intelligence`;

export async function getOverview(params = {}) {
  const sp = new URLSearchParams(params).toString();
  const r = await fetchWithAuth(`${BASE}/overview${sp ? `?${sp}` : ""}`);
  return r.json();
}

export async function getInsights(params = {}) {
  const sp = new URLSearchParams(params).toString();
  const r = await fetchWithAuth(`${BASE}/insights${sp ? `?${sp}` : ""}`);
  return r.json();
}

export async function getFunnel(params = {}) {
  const sp = new URLSearchParams(params).toString();
  const r = await fetchWithAuth(`${BASE}/funnel${sp ? `?${sp}` : ""}`);
  return r.json();
}

export async function getCampaignSuggestions() {
  const r = await fetchWithAuth(`${BASE}/campaign-suggestions`);
  return r.json();
}

export async function getEnquiriesByCampaign(params = {}) {
  const sp = new URLSearchParams(params).toString();
  const r = await fetchWithAuth(`${BASE}/analytics/enquiries-by-campaign${sp ? `?${sp}` : ""}`);
  const data = await r.json();
  return data.data || [];
}

export async function getEnquiriesBySource(params = {}) {
  const sp = new URLSearchParams(params).toString();
  const r = await fetchWithAuth(`${BASE}/analytics/enquiries-by-source${sp ? `?${sp}` : ""}`);
  const data = await r.json();
  return data.data || [];
}

export async function getEnquiriesByCounsellor(params = {}) {
  const sp = new URLSearchParams(params).toString();
  const r = await fetchWithAuth(`${BASE}/analytics/enquiries-by-counsellor${sp ? `?${sp}` : ""}`);
  const data = await r.json();
  return data.data || [];
}

export async function getEnquiriesByProgram(params = {}) {
  const sp = new URLSearchParams(params).toString();
  const r = await fetchWithAuth(`${BASE}/analytics/enquiries-by-program${sp ? `?${sp}` : ""}`);
  const data = await r.json();
  return data.data || [];
}

export async function getEnquiriesByCourse(params = {}) {
  const sp = new URLSearchParams(params).toString();
  const r = await fetchWithAuth(`${BASE}/analytics/enquiries-by-course${sp ? `?${sp}` : ""}`);
  const data = await r.json();
  return data.data || [];
}

export async function getRevenueByCampaign(params = {}) {
  const sp = new URLSearchParams(params).toString();
  const r = await fetchWithAuth(`${BASE}/analytics/revenue-by-campaign${sp ? `?${sp}` : ""}`);
  const data = await r.json();
  return data.data || [];
}

export async function getRevenueByCounsellor(params = {}) {
  const sp = new URLSearchParams(params).toString();
  const r = await fetchWithAuth(`${BASE}/analytics/revenue-by-counsellor${sp ? `?${sp}` : ""}`);
  const data = await r.json();
  return data.data || [];
}

export async function getRevenueByProgram(params = {}) {
  const sp = new URLSearchParams(params).toString();
  const r = await fetchWithAuth(`${BASE}/analytics/revenue-by-program${sp ? `?${sp}` : ""}`);
  const data = await r.json();
  return data.data || [];
}

export async function getRevenueByCourse(params = {}) {
  const sp = new URLSearchParams(params).toString();
  const r = await fetchWithAuth(`${BASE}/analytics/revenue-by-course${sp ? `?${sp}` : ""}`);
  const data = await r.json();
  return data.data || [];
}

export async function getRevenueByMedium(params = {}) {
  const sp = new URLSearchParams(params).toString();
  const r = await fetchWithAuth(`${BASE}/analytics/revenue-by-medium${sp ? `?${sp}` : ""}`);
  const data = await r.json();
  return data.data || [];
}

export async function listCampaigns(limit = 100, offset = 0) {
  const r = await fetchWithAuth(`${BASE}/campaigns?limit=${limit}&offset=${offset}`);
  return r.json();
}

export async function getCampaign(id) {
  const r = await fetchWithAuth(`${BASE}/campaigns/${id}`);
  if (!r.ok) return null;
  return r.json();
}

export async function createCampaign(body) {
  const r = await fetchWithAuth(`${BASE}/campaigns`, {
    method: "POST",
    body: JSON.stringify(body),
  });
  return r.json();
}

export async function updateCampaign(id, body) {
  const r = await fetchWithAuth(`${BASE}/campaigns/${id}`, {
    method: "PUT",
    body: JSON.stringify(body),
  });
  return r.json();
}

export async function deleteCampaign(id) {
  const r = await fetchWithAuth(`${BASE}/campaigns/${id}`, { method: "DELETE" });
  return r.ok;
}

export async function getCounsellors() {
  const r = await fetchWithAuth(`${BASE}/counsellors`);
  const data = await r.json();
  return data.data || [];
}

export async function getSourcesList() {
  const r = await fetchWithAuth(`${BASE}/sources/list`);
  const data = await r.json();
  return data.data || [];
}

export async function setSourceCampaign(sourceId, campaignId) {
  const r = await fetchWithAuth(`${BASE}/sources/${sourceId}/campaign`, {
    method: "PUT",
    body: JSON.stringify({ campaign_id: campaignId || null }),
  });
  return r.json();
}

export async function createSource(name, campaignId = null) {
  const r = await fetchWithAuth(`${BASE}/sources`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ name: (name || "").trim(), campaign_id: campaignId }),
  });
  if (!r.ok) {
    const err = await r.json().catch(() => ({}));
    throw new Error(err.error || "Failed to create source");
  }
  return r.json();
}

function buildParams(params) {
  const sp = new URLSearchParams();
  Object.entries(params || {}).forEach(([k, v]) => {
    if (v !== undefined && v !== null && v !== "") sp.set(k, v);
  });
  return sp.toString();
}

export async function getRevenueCounsellorsPaginated(params) {
  const q = buildParams(params);
  const r = await fetchWithAuth(`${BASE}/analytics/revenue/counsellors${q ? `?${q}` : ""}`);
  return r.json();
}

export async function getRevenueProgramsPaginated(params) {
  const q = buildParams(params);
  const r = await fetchWithAuth(`${BASE}/analytics/revenue/programs${q ? `?${q}` : ""}`);
  return r.json();
}

export async function getRevenueCoursesPaginated(params) {
  const q = buildParams(params);
  const r = await fetchWithAuth(`${BASE}/analytics/revenue/courses${q ? `?${q}` : ""}`);
  return r.json();
}

export async function getRevenueCampaignsPaginated(params) {
  const q = buildParams(params);
  const r = await fetchWithAuth(`${BASE}/analytics/revenue/campaigns${q ? `?${q}` : ""}`);
  return r.json();
}

export async function getRevenueMediumsPaginated(params) {
  const q = buildParams(params);
  const r = await fetchWithAuth(`${BASE}/analytics/revenue/mediums${q ? `?${q}` : ""}`);
  return r.json();
}

export async function getCounsellorProfile(id, params = {}) {
  const q = buildParams(params);
  const r = await fetchWithAuth(`${BASE}/counsellors/${id}/profile${q ? `?${q}` : ""}`);
  if (!r.ok) return null;
  return r.json();
}

export async function getStaffIncentives(id, params = {}) {
  const q = buildParams(params);
  const r = await fetchWithAuth(`${BASE}/counsellors/${id}/incentives${q ? `?${q}` : ""}`);
  if (!r.ok) return null;
  return r.json();
}

export async function getProgramsList() {
  const r = await fetchWithAuth(`${BASE}/programs`);
  const data = await r.json();
  return data.data || [];
}

export async function getCoursesList(programId) {
  const r = await fetchWithAuth(`${BASE}/courses${programId != null ? `?program_id=${programId}` : ""}`);
  const data = await r.json();
  return data.data || [];
}
